import { useTranslation } from 'react-i18next';
import { locations } from 'services/routes/locations';
import { StyledNavbar, StyledNavLink } from './styled';

const ReleasesNavbar = () => {
  const { t } = useTranslation();

  return (
    <StyledNavbar>
      <StyledNavLink to={locations.releases.all.route}>
        {t('distribution:releases:list:all')}
      </StyledNavLink>
      <StyledNavLink to={locations.releases.draft.route}>
        {t('distribution:releases:list:draft')}
      </StyledNavLink>
      <StyledNavLink to={locations.releases.pending.route}>
        {t('distribution:releases:list:pending')}
      </StyledNavLink>
      <StyledNavLink to={locations.releases.released.route}>
        {t('distribution:releases:list:released')}
      </StyledNavLink>
    </StyledNavbar>
  );
};

export default ReleasesNavbar;
